import React from 'react';
import PropTypes from 'prop-types';
import dataModel from '../../models/DataModel';
import AttachmentDisplay from '../../containers/PORContainer/PORProjectDocuments/AttachmentsTable/AttachmentDisplay';
import './DocumentPopup.scss';

export default class DocumentPopup extends React.Component {

  constructor(props) {
    super(props);
    DocumentPopup.propTypes = {
      /** document (closeout, ref doc, etc) to display */
      document: PropTypes.object.isRequired,
      /** handler for the close button */
      onClose: PropTypes.func.isRequired,
    };
    this.state = {
      /** when true a fade-out animation is applied */
      closing: false,
    };

    this.handleClose = this.handleClose.bind(this);
  }

  componentDidMount() {
    dataModel.setDisableAppBackground(true);
  }
  componentWillUnmount() {
    dataModel.setDisableAppBackground(false);
  }

  handleClose() {
    this.setState({ closing: true });
    setTimeout(this.props.onClose, 400);
  }

  render() {
    const { closing } = this.state;
    
    return (
      <div className={'document-popup' + (closing ? ' document-popup--closing' : '')}>
        <span className='document-popup__close-button' onClick={this.handleClose}>&times;</span>
        <AttachmentDisplay
          attachment={this.props.document}
          hasDeleteButton={false}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/DocumentPopup/index.js